module.exports = __webpack_public_path__ + "img/joinCloud1.4f93819d.png";